import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Company_details() {
    const navigate = useNavigate();
    const [selectedComId, setSelectedComId] = useState('');
    const [selectedComName, setSelectedComName] = useState('');
    const [selectedComLogo, setSelectedComLogo] = useState('');
    useEffect(() => {
        var comname = localStorage.getItem('mem_company_name');
        setSelectedComName(comname);
        var comid = localStorage.getItem('mem_company_id');
        setSelectedComId(comid);
        var comlogo = localStorage.getItem('companylogo');
        setSelectedComLogo(comlogo);
         loadCompanyData(comid)

    }, []);

    const loadCompanyData = async (comid) => {
        try {
            const response = await fetch(`getCompanyDetails.php?uuid=${comid}`);
            const result = await response.json();

            if (result.status === "success") {
                prefilldata(result.data);
            } else {
                console.warn("No data found for this UUID");
            }
        } catch (err) {
            console.error("Error loading draft:", err);
        }
    }

    function prefilldata(data){
        $('#bis_details').val(data.business_address)
        $('#bis_phone').val(data.business_phone)
        $('#bis_email').val(data.business_email)
        $('#bis_ceo_name').val(data.ceo_name)
        $('#reg_name').val(data.registered_name)
    }

    function startCloseEdit() {
        var btncaption = $('#editcancel').text();
        if (btncaption === 'Edit') {
            $('#editcancel').text("Cancel Edit");
            $('#editcancel').addClass("cancle_btn");
            $('.profile_update_btn').removeClass('nodisplay')
            var idarr = getAllInputFieldIds();
            console.log(idarr)
            var len = idarr.length;
            for (var i = 0; i < len; i++) {
                var trginput = idarr[i];
                $('#' + trginput).addClass('vl_dsh_setBorder');
                $('#' + trginput).removeAttr('readonly');
            }
        } else if (btncaption === 'Cancel Edit') {
            $('#editcancel').text("Edit");
            $('#editcancel').removeClass("cancle_btn");
            $('.profile_update_btn').addClass('nodisplay');
            var idarrcancel = getAllInputFieldIds();
            var leng = idarrcancel.length;
            for (var j = 0; j < leng; j++) {
                var trginputcancel = idarrcancel[j];
                $('#' + trginputcancel).removeClass('vl_dsh_setBorder');
                $('#' + trginputcancel).attr('readonly', 'true');
            }
        }
    }

    function getAllInputFieldIds() {
        const inputFields = document.querySelectorAll('#all_fields_holder input');
        const inputFieldIds = Array.from(inputFields).map(input => input.id);
        return inputFieldIds;
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function updateDetails(){
        let mem_company_id = localStorage.getItem('mem_company_id');
       const formData = new FormData();
        formData.append('ceo_name', $('#bis_ceo_name').val());
        formData.append('business_email', $('#bis_email').val());
        formData.append('com_id', mem_company_id);
        formData.append('registered_name', $('#reg_name').val());
        formData.append('business_address', $('#bis_details').val());
        formData.append('business_phone', $('#bis_phone').val());
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('updateCompanyDetails.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    startCloseEdit();
                } else {
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Image upload failed");
            });
    }

    return (
        <div>
            <div className='editbtn_holder'>
                <div className='membersinfoimg fullwidth'>
                    <div className='memberimgholder'>
                        <img id="memimg" src={selectedComLogo} />
                    </div>
                    <h2 id="companyname">{selectedComName}</h2>
                    <button className='editbtndetails' id="editcancel" onClick={startCloseEdit}>Edit</button>
                </div>
            </div>
            <div className='vl_dsh_one_full' id="all_fields_holder">
                <div className='vl_dsh_formnholder'>
                <div className='vl_dsh_one_half'>
                    
                    <div className='formfieldcommon'>
                        <label>Business Address</label>
                        <textarea id="bis_details"></textarea>
                    </div>
                    <div className='formfieldcommon'>
                        <label>Business Phone</label>
                        <input type="tel" id="bis_phone" placeholder='Insert Phone' readOnly />
                    </div>
                    <div className='formfieldcommon'>
                        <label>Business Email</label>
                        <input type="email" id="bis_email" placeholder='Insert Email' readOnly />
                    </div>
                </div>
                <div className='vl_dsh_one_half'>
                    <div className='formfieldcommon'>
                        <label>CEO Name</label>
                        <input type="text" id="bis_ceo_name" placeholder='Insert CEO Name' readOnly />
                    </div>
                    <div className='formfieldcommon'>
                        <label>Comany Registered Name</label>
                        <input type="text" id="reg_name" placeholder='Insert registered Name' readOnly />
                    </div>
                    <div className='vl_dsh_btn_holder text_right nodisplay profile_update_btn'>
                        <button onClick={updateDetails}>Update</button>
                    </div>
                </div>
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
